import { STATS } from '@lib/constants';
import AnimatedCounter from '@components/common/AnimatedCounter';

const StatsSection = () => {
  return (
    <section
      className="py-12 sm:py-16 md:py-20 px-4 border-y"
      style={{
        backgroundColor: 'var(--color-theme-2)',
        borderColor: 'var(--color-border-light)'
      }}
    >
      <div className="container mx-auto max-w-7xl">
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-6 sm:gap-8 lg:gap-12">
          {STATS.map((stat, index) => (
            <div key={index} className="text-center space-y-1 sm:space-y-2">
              <div
                className="text-3xl sm:text-4xl md:text-5xl font-bold tracking-tight"
                style={{ color: 'var(--color-accent-6)' }}
              >
                <AnimatedCounter value={stat.value} />
              </div>
              <div
                className="text-xs sm:text-sm md:text-base font-medium px-2"
                style={{ color: 'var(--color-subtle)' }}
              >
                {stat.label}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default StatsSection;
